import React, { Component } from 'react';
import { connect } from 'react-redux';
import clearSession from '../../actions/clear-session';
import { havePendingActionToConsider } from '../../reducers/userActivityReducer';
import { showKioskWarning } from "../../reducers/kioskWarningReducer";
import { isUser } from '../../reducers/userReducer';

class PaymentKioskTimeoutKicker extends Component {
    constructor(props) {
        super(props);
        this.kickCallbackWithTimeout = null;
        this.inactivityWarningModalCallbackWithTimeout = null;
    }

    refreshTimeout = (kickTimeoutMilliSeconds, kickTimeoutCallback, windowTimeoutMilliSeconds, windowTimeoutCallback) => {
        if (this.kickCallbackWithTimeout != null) {
            clearTimeout(this.kickCallbackWithTimeout);
        }
        if (this.inactivityWarningModalCallbackWithTimeout != null) {
            clearTimeout(this.inactivityWarningModalCallbackWithTimeout);
        }
        this.kickCallbackWithTimeout = setTimeout(kickTimeoutCallback, kickTimeoutMilliSeconds);
        this.inactivityWarningModalCallbackWithTimeout = setTimeout(() => {
            if (!!this.props.kioskToken && this.props.isUser) {
                windowTimeoutCallback()
            }
        }, windowTimeoutMilliSeconds);
    };

    setUpRefresh() {
        const kickTimeoutMilliSeconds = this.props.kickTimeoutMilliSeconds || 100000;
        const kickTimeoutCallback = () => {
            if (!!this.props.kioskToken && this.props.isUser) {
                this.props.clearSession();
            }
        }

        const windowTimeoutMilliSeconds = kickTimeoutMilliSeconds - this.props.inactivityWarningDialogDurationMilliSeconds;
        const windowTimeoutCallback = this.props.openInactivityWarning;
        this.refreshTimeout(kickTimeoutMilliSeconds, kickTimeoutCallback, windowTimeoutMilliSeconds, windowTimeoutCallback);
    }

    componentDidMount() {
        this.setUpRefresh();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isKioskModeEnabled !== this.props.isKioskModeEnabled && !this.props.isKioskModeEnabled) {
            clearTimeout(this.kickCallbackWithTimeout);
            clearTimeout(this.inactivityWarningModalCallbackWithTimeout);
        }

        if (this.props.isKioskModeEnabled) {
            const shouldSetupRefresh =
                (prevProps.needToConsiderUserAction !== this.props.needToConsiderUserAction && this.props.needToConsiderUserAction) ||
                (prevProps.isUser !== this.props.isUser && this.props.isUser);

            if (shouldSetupRefresh) {
                this.setUpRefresh();
            }
        }
    }

    render() {
        return (
            <div>
                {this.props.children}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const isKioskModeEnabled = false;

    return {
        kickTimeoutMilliSeconds: 10 * 1000 * 60, // config specified in minutes
        inactivityWarningDialogDurationMilliSeconds: 1000 * 60, // 1 minute
        needToConsiderUserAction: havePendingActionToConsider(state),
        isKioskModeEnabled,
        isUser: isUser(state),
        kioskToken: state.kioskUser.tokens.token
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        refresh: () => dispatch(refresh()),
        clearSession: () => dispatch(clearSession()),
        openInactivityWarning: () => dispatch(showKioskWarning({
            warningType: 'INACTIVITY_WARNING'
        }))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentKioskTimeoutKicker);



// WEBPACK FOOTER //
// ./src/components/KioskTimeoutKicker/PaymentKioskTimeoutKicker.jsx